export default {
    name: '',
    quantity: 1,
    price: 0,
    subtotal: 0,
    valid: false,
};